export default "__VITE_ASSET__DDp_PBsK__"